// extracted by mini-css-extract-plugin
export default {"headphones":"style_headphones__R1X0q","centerImg":"style_centerImg__tmpv3","frameA":"style_frameA__-B-4L","frameB":"style_frameB__1H-uB"};